<script>
    import { tooltip } from "@svelte-plugins/tooltips";

    import { getTooltipDisplayOptions } from '../stores';
    import { formatDate } from '../date-time';

    import AimTooltip from './AimTooltip.svelte'
    
    export let id;
    export let score;
    export let label = undefined;
    export let lastDate = undefined;
    export let changeDate = undefined;
    export let recentChange = false;
    export let attendedLabel = "Attended";
    export let additionalTooltipText = undefined;

    export let showBadge = true;
    export let showLabel = true;

    function getTooltipProps() {
        let tooltipContent = [];

        if (additionalTooltipText) {
            tooltipContent.push(additionalTooltipText);
        }

        if (lastDate) {
            tooltipContent.push("Last " + attendedLabel +  ": " +  formatDate(lastDate));
        }
        
        if (changeDate) {
            tooltipContent.push("Level Changed: " +  formatDate(changeDate));
        }

        return {tooltipLines: tooltipContent};
    }
</script>

<style>
    .badge {
        width: 72px;
        font-size: 11px;
        padding: 4px 0;
    }

    .badge-short {
        width: 58px;
    }

    .badge-success.badge-label-hidden {
        color: #28a745;
    }

    .badge-warning.badge-label-hidden {
        color: #ffc107;
    }

    .badge-primary.badge-label-hidden {
        color: #007bff;
    }

    .badge-danger.badge-label-hidden {
        color: #dc3545;
    }

    .badge-light {
        background-color: #b2b4b5;
        color: white;
    }

    .badge-light.badge-label-hidden {
        color: #b2b4b5;
    }

    .badge-hidden {
	    display: none;
    }

    .badge-recent {
        border: 2px solid #7d2028;
        padding: 2px 0;
    }
</style>
{#if changeDate != null || lastDate != null}
    <span {id} class="badge"
        class:badge-short={!showLabel}
        class:badge-hidden={!showBadge && score > 1}
        class:badge-label-hidden={!showLabel || label == null}
        class:badge-success={score == 4.0}
        class:badge-primary={score == 3.5}
        class:badge-light={score == 3.0}
        class:badge-warning={score == 2.0}
        class:badge-danger={score == 1.0}
        class:badge-recent={recentChange}
        use:tooltip={{
            content: {
                component: AimTooltip ,
                props: getTooltipProps()
            },
            ...getTooltipDisplayOptions({ maxWidth: 220 })
        }}>
        {(label) ? label : '-'}
    </span>
{:else}
    <span {id} class="badge"
        class:badge-short={!showLabel}
        class:badge-hidden={!showBadge && score > 1}
        class:badge-label-hidden={!showLabel || label == null}
        class:badge-success={score == 4.0}
        class:badge-primary={score == 3.5}
        class:badge-light={score == 3.0}
        class:badge-warning={score == 2.0}
        class:badge-danger={score == 1.0}
        class:badge-recent={recentChange}>
        {(label) ? label : '-'}
    </span>
{/if}


